import React from 'react';

const ProjectAccordionWrapper = ({
	headerContent,
	bodyContent,
	containerKey,
	accordionId,
	iconColor = '#21242B',
	groupId,
	stageVisibilityResponse = [],
	onAccordionToggle
}) => {
	const findStageVisibility = () => {
		if (!stageVisibilityResponse || stageVisibilityResponse.length === 0) {
			return 'true';
		}

		const idx = stageVisibilityResponse.findIndex((item) => parseInt(item?.id) === parseInt(groupId));
		if (idx === -1) {
			return 'true';
		}
		return stageVisibilityResponse[idx]?.value === 'OPEN' ? 'true' : 'false';
	};

	return (
		<div key={containerKey} className="common-accordion bg-white">
			<div className="accordion border-0" id="accordionExample">
				<div className="card mb-0">
					<div className="card-header" id={`heading-${accordionId}`}>
						<h2 className="mb-0">
							<button
								className="btn btn-link pb-0 d-flex justify-content text-left gray_dark_01 regular-14 weight-600 p-0"
								type="button"
								onClick={() => onAccordionToggle(groupId)}
								aria-expanded={findStageVisibility()}
								aria-controls={`tableCollapse-${accordionId}`}
							>
								<div className="arrow-down">
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
										style={{
											transform:
												findStageVisibility() !== 'true'
													? 'rotate(180deg)'
													: 'rotate(0deg)',
											transition: 'transform 0.3s ease'
										}}
									>
										<path
											d="M5 7.5L10 12.5L15 7.5"
											stroke={iconColor}
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										></path>
									</svg>
								</div>
								<div>{headerContent}</div>
							</button>
						</h2>
					</div>
					<div
						id={`tableCollapse-${accordionId}`}
						className={`collapse ${findStageVisibility() === 'true' ? 'show' : ''}`}
						aria-labelledby={`heading-${accordionId}`}
						data-parent="#accordionExample"
					>
						<div className="card-body p-0 border-0 bg-white">{bodyContent}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectAccordionWrapper;
